module.exports = __webpack_public_path__ + "static/media/calendar.666e8d8e.svg";